const problemQuality = {
  complete: [
  "132-pattern",
  "3sum",
  "3sum-closest",
  "3sum-smaller",
  "add-two-numbers",
  "add-two-numbers-ii",
  "alien-dictionary",
  "all-paths-from-source-to-target",
  "allocate-mailboxes",
  "basic-calculator",
  "best-time-to-buy-and-sell-stock",
  "best-time-to-buy-and-sell-stock-ii",
  "best-time-to-buy-and-sell-stock-iii",
  "best-time-to-buy-and-sell-stock-iv",
  "best-time-to-buy-and-sell-stock-with-cooldown",
  "best-time-to-buy-and-sell-stock-with-transaction-fee",
  "binary-search",
  "binary-search-tree-iterator",
  "binary-subarrays-with-sum",
  "binary-tree-inorder-traversal",
  "binary-tree-level-order-traversal",
  "binary-tree-maximum-path-sum",
  "can-make-palindrome-from-substring",
  "cheapest-flights-within-k-stops",
  "check-if-a-parentheses-string-can-be-valid",
  "choose-k-elements-with-maximum-sum",
  "climbing-stairs",
  "clone-graph",
  "coin-change",
  "combination-sum",
  "combination-sum-ii",
  "combination-sum-iii",
  "combinations",
  "construct-binary-tree-from-preorder-and-inorder-traversal",
  "construct-binary-tree-from-preorder-and-postorder-traversal",
  "construct-quad-tree",
  "construct-string-with-minimum-cost",
  "container-with-most-water",
  "contains-duplicate",
  "contains-duplicate-ii",
  "contains-duplicate-iii",
  "continuous-subarray-sum",
  "continuous-subarrays",
  "copy-list-with-random-pointer",
  "count-days-without-meetings",
  "count-integers-in-intervals",
  "count-number-of-nice-subarrays",
  "count-numbers-with-non-decreasing-digits",
  "count-of-integers",
  "count-of-interesting-subarrays",
  "count-of-smaller-numbers-after-self",
  "count-stepping-numbers-in-range",
  "count-sub-islands",
  "course-schedule",
  "course-schedule-ii",
  "course-schedule-iv",
  "daily-temperatures",
  "decode-string",
  "decode-ways",
  "delete-node-in-a-linked-list",
  "design-add-and-search-words-data-structure",
  "different-palindromic-substrings",
  "different-ways-to-add-parentheses",
  "distribute-coins-in-binary-tree",
  "divide-chocolate",
  "divide-intervals-into-minimum-number-of-groups",
  "divide-players-into-teams-of-equal-skill",
  "domino-and-tromino-tiling",
  "edit-distance",
  "evaluate-division",
  "fibonacci-number",
  "fill-a-special-grid",
  "find-all-anagrams-in-a-string",
  "find-eventual-safe-states",
  "find-first-and-last-position-of-element-in-sorted-array",
  "find-if-path-exists-in-graph",
  "find-in-mountain-array",
  "find-median-from-data-stream",
  "find-peak-element",
  "find-the-k-beauty-of-a-number",
  "find-the-kth-largest-integer-in-the-array",
  "find-the-original-array-of-prefix-xor",
  "find-the-shortest-superstring",
  "find-x-sum-of-all-k-long-subarrays-ii",
  "finding-mk-average",
  "first-bad-version",
  "fizz-buzz",
  "frog-jump",
  "fruit-into-baskets",
  "furthest-building-you-can-reach",
  "generate-parentheses",
  "grid-teleportation-traversal",
  "group-anagrams",
  "house-robber",
  "house-robber-ii",
  "implement-stack-using-queues",
  "implement-trie",
  "implement-trie-ii-prefix-tree",
  "implement-trie-prefix-tree",
  "insert-delete-getrandom-o",
  "insert-interval",
  "interval-list-intersections",
  "invert-binary-tree",
  "is-graph-bipartite",
  "jump-game",
  "jump-game-ii",
  "k-closest-points-to-origin",
  "k-empty-slots",
  "k-radius-subarray-averages",
  "keys-and-rooms",
  "knight-dialer",
  "koko-eating-bananas",
  "kth-ancestor-of-a-tree-node",
  "kth-largest-element-in-an-array",
  "largest-rectangle-in-histogram",
  "length-of-longest-fibonacci-subsequence",
  "length-of-the-longest-increasing-path",
  "letter-combinations-of-a-phone-number",
  "lfu-cache",
  "linked-list-cycle",
  "longest-common-prefix",
  "longest-common-subsequence",
  "longest-continuous-subarray-with-absolute-diff-less-than-or-equal-to-limit",
  "longest-increasing-subsequence",
  "longest-increasing-subsequence-ii",
  "longest-nice-subarray",
  "longest-palindromic-subsequence",
  "longest-palindromic-subsequence-ii",
  "longest-palindromic-substring",
  "longest-substring-with-at-most-k-distinct-characters",
  "longest-substring-without-repeating-characters",
  "lowest-common-ancestor-of-a-binary-search-tree",
  "lowest-common-ancestor-of-a-binary-tree",
  "lowest-common-ancestor-of-a-binary-tree-ii",
  "lowest-common-ancestor-of-a-binary-tree-iii",
  "lru-cache",
  "make-sum-divisible-by-p",
  "making-a-large-island",
  "max-area-of-island",
  "max-consecutive-ones-iii",
  "max-points-on-a-line",
  "maximal-rectangle",
  "maximal-square",
  "maximize-greatness-of-an-array",
  "maximize-profit-from-task-assignment",
  "maximize-score-after-n-operations",
  "maximize-the-confusion-of-an-exam",
  "maximize-the-number-of-target-nodes-after-connecting-trees-i",
  "maximize-win-from-two-segments",
  "maximum-average-subarray-ii",
  "maximum-candies-allocated-to-k-children",
  "maximum-depth-of-binary-tree",
  "maximum-earnings-from-taxi",
  "maximum-number-of-events-that-can-be-attended-ii",
  "maximum-number-of-fish-in-a-grid",
  "maximum-product-subarray",
  "maximum-profit-in-job-scheduling",
  "maximum-students-taking-exam",
  "maximum-subarray",
  "maximum-sum-with-at-most-k-elements",
  "maximum-weighted-k-edge-path",
  "maximum-xor-of-two-numbers-in-an-array",
  "maximum-xor-with-an-element-from-array",
  "median-of-two-sorted-arrays",
  "meeting-rooms",
  "meeting-rooms-ii",
  "merge-intervals",
  "merge-k-sorted-lists",
  "merge-sorted-array",
  "merge-two-sorted-lists",
  "middle-of-the-linked-list",
  "min-cost-climbing-stairs",
  "min-stack",
  "minimum-absolute-difference-in-sliding-submatrix",
  "minimum-add-to-make-parentheses-valid",
  "minimum-consecutive-cards-to-pick-up",
  "minimum-cost-for-tickets",
  "minimum-cost-to-make-at-least-one-valid-path-in-a-grid",
  "minimum-cost-to-reach-destination-in-time",
  "minimum-depth-of-binary-tree",
  "minimum-falling-path-sum",
  "minimum-falling-path-sum-ii",
  "minimum-genetic-mutation",
  "minimum-moves-to-clean-the-classroom",
  "minimum-number-of-swaps-to-make-the-string-balanced",
  "minimum-number-of-valid-strings-to-form-target-i",
  "minimum-path-cost-in-a-grid",
  "minimum-path-sum",
  "minimum-remove-to-make-valid-parentheses",
  "minimum-sideway-jumps",
  "minimum-size-subarray-sum",
  "minimum-swaps-to-sort-by-digit-sum",
  "minimum-time-to-complete-trips",
  "minimum-time-to-kill-all-monsters",
  "minimum-time-to-visit-all-houses",
  "minimum-weighted-subgraph-with-the-required-paths-ii",
  "minimum-window-substring",
  "my-calendar-i",
  "my-calendar-ii",
  "my-calendar-iii",
  "n-queens",
  "network-delay-time",
  "next-greater-element-i",
  "next-greater-element-ii",
  "number-of-1-bits",
  "number-of-atoms",
  "number-of-beautiful-integers-in-the-range",
  "number-of-connected-components-in-an-undirected-graph",
  "number-of-distinct-islands",
  "number-of-flowers-in-full-bloom",
  "number-of-islands",
  "number-of-provinces",
  "number-of-sub-arrays-with-odd-sum",
  "number-of-substrings-containing-all-three-characters",
  "number-of-visible-people-in-a-queue",
  "number-of-ways-to-build-sturdy-brick-wall",
  "number-of-ways-to-wear-different-hats-to-each-other",
  "online-stock-span",
  "pacific-atlantic-water-flow",
  "paint-fence",
  "paint-house",
  "paint-house-ii",
  "palindrome-partitioning",
  "palindromic-substrings",
  "partition-equal-subset-sum",
  "partition-list",
  "partition-to-k-equal-sum-subsets",
  "path-sum",
  "path-with-maximum-minimum-value",
  "path-with-maximum-probability",
  "path-with-minimum-effort",
  "permutation-in-string",
  "permutations",
  "permutations-ii",
  "power-of-three",
  "product-of-array-except-self",
  "random-pick-with-weight",
  "range-sum-query-2d-immutable",
  "range-sum-query-immutable",
  "range-sum-query-mutable",
  "redundant-connection",
  "regular-expression-matching",
  "remove-covered-intervals",
  "remove-interval",
  "remove-invalid-parentheses",
  "remove-nth-node-from-end-of-list",
  "reverse-linked-list",
  "reverse-linked-list-ii",
  "reverse-string",
  "rotate-array",
  "rotate-list",
  "rotting-oranges",
  "russian-doll-envelopes",
  "same-tree",
  "search-in-rotated-sorted-array",
  "search-insert-position",
  "sequential-grid-path-cover",
  "sequentially-ordinal-rank-tracker",
  "serialize-and-deserialize-binary-tree",
  "shortest-common-supersequence",
  "shortest-distance-from-all-buildings",
  "shortest-path-visiting-all-nodes",
  "sliding-window-maximum",
  "sliding-window-median",
  "smallest-common-region",
  "smallest-sufficient-team",
  "sort-an-array",
  "special-permutations",
  "split-array-largest-sum",
  "sqrt",
  "stone-game-ii",
  "subarray-sum-equals-k",
  "subarray-sums-divisible-by-k",
  "subarrays-with-k-different-integers",
  "subsets",
  "subsets-ii",
  "substrings-of-size-three-with-distinct-characters",
  "subtree-inversion-sum",
  "sum-of-distances-in-tree",
  "sum-of-subarray-minimums",
  "sum-of-subarray-ranges",
  "sum-of-total-strength-of-wizards",
  "sum-root-to-leaf-numbers",
  "surrounded-regions",
  "symmetric-tree",
  "the-maze",
  "the-maze-ii",
  "the-number-of-weak-characters-in-the-game",
  "the-skyline-problem",
  "three-sum",
  "top-k-frequent-elements",
  "top-k-frequent-words",
  "trapping-rain-water",
  "trapping-rain-water-ii",
  "two-best-non-overlapping-events",
  "two-sum",
  "two-sum-ii-input-array-is-sorted",
  "two-sum-less-than-k",
  "unique-binary-search-trees",
  "unique-binary-search-trees-ii",
  "unique-paths",
  "unique-paths-ii",
  "unit-conversion-i",
  "unit-conversion-ii",
  "valid-anagram",
  "valid-palindrome",
  "valid-palindrome-ii",
  "valid-palindrome-iii",
  "valid-palindrome-iv",
  "valid-parentheses",
  "valid-parenthesis-string",
  "valid-triangle-number",
  "validate-binary-search-tree",
  "wildcard-matching",
  "word-break",
  "words-within-two-edits-of-dictionary"
],
  simplified: [

],
  needsCuration: [

],
};

export function getProblemQuality(problemId) {
  if (problemQuality.complete.includes(problemId)) return { tier: 'complete', label: 'Verified' };
  if (problemQuality.simplified.includes(problemId)) return { tier: 'simplified', label: 'Adapted' };
  if (problemQuality.needsCuration.includes(problemId)) return { tier: 'needsCuration', label: 'Needs curation' };
  return { tier: 'unknown', label: 'Unreviewed' };
}

export function getProblemQualityCounts() {
  return {
    complete: problemQuality.complete.length,
    simplified: problemQuality.simplified.length,
    needsCuration: problemQuality.needsCuration.length,
  };
}

export default problemQuality;
